import { Route, Routes } from "react-router-dom"
import AdminContainers from '../containers/AdminContainer';
import Home from '../components/backoffice/dashboard/Home';
import ItemsMain from '../components/backoffice/asset/Items/index';
import InspectMain from "../components/backoffice/asset/inspect";
import InspectHistMain from "../components/backoffice/asset/inspect/hist";
import InoutMain from '../components/backoffice/asset/inout/index';
import MainContainer from "../containers/MainContainer";
import Main from "../components/front/Main";
import MInoutMain from '../components/front/inout/index';
import OutControl from "../components/front/inout/OutControl";
import InControl from "../components/front/inout/InControl";
import MInspectMain from "../components/front/inspect";
import InspectControl from '../components/front/inspect/InspectControl';
import Hist from "../components/backoffice/asset/Items/Hist";
import ItemInfo from "../components/front/item";
import RelMain from "../components/front/item/rel";
import ItemsRelMain from "../components/backoffice/asset/Items/rel";
import InspectItemInfo from '../components/front/item/inspect/index';
import InoutHist from '../components/backoffice/asset/inout/InoutHist';
import InoutHistMain from '../components/backoffice/asset/inout/hist/index';
import Password from '../components/backoffice/setting/Password';
import DMain from '../components/backoffice/dashboard/Main';
import StaticItem from '../components/backoffice/static/StaticItem';
import StaticSearchItem from "../components/backoffice/static/StaticSearchItem";
import StaticInout from "../components/backoffice/static/StaticInout";
import StaticInspect from "../components/backoffice/static/StaticInspect";
import Users from "../components/backoffice/setting/Users";
import InoutMod from "../components/backoffice/asset/inout/mod";
import Supplies from "../components/backoffice/asset/supplies";
import Client from "../components/backoffice/setting/client";
import OnlyInControl from "../components/front/inout/AllInControl";

const MainRoutes = () => {
    return (
        <Routes>
            {/** Mobile */}
            <Route path="/" element={<MainContainer target={<Main />}/>} />

            <Route path="/inout" element={<MainContainer target={<MInoutMain />}/>} />
            <Route path="/inout/:iot_tp" element={<MainContainer target={<MInoutMain />}/>} />
            <Route path="/inout/:sno/out" element={<MainContainer target={<OutControl />}/>} />
            <Route path="/inout/:sno/in" element={<MainContainer target={<InControl />}/>} />
            <Route path="/inout/onlyIn" element={<MainContainer target={<OnlyInControl />}/>} />

            <Route path="/inspect" element={<MainContainer target={<MInspectMain />}/>} />
            <Route path="/inspect/:isp_tp" element={<MainContainer target={<MInspectMain />}/>} />
            <Route path="/inspect/add/:sno" element={<MainContainer target={<InspectControl />}/>} />
            <Route path="/inspect/item" element={<MainContainer target={<InspectItemInfo />}/>} />

            <Route path="/itemInout" element={<MainContainer target={<ItemInfo />}/>} />
            <Route path="/relInfo" element={<MainContainer target={<RelMain />}/>} />

            {/** BACK OFFICE */}
            {/* <Route path="/admin" element={<AdminContainers target={<Home />} />} /> */}
            <Route path="/admin" element={<AdminContainers target={<DMain />} menuKey='DASHBOARD'/>} />

            {/** BACK OFFICE ASSET */}
            <Route path="/admin/items" element={<AdminContainers target={<ItemsMain />} menuKey='ITEM_LIST'/>} />
            <Route path="/admin/items/hist" element={<AdminContainers target={<Hist />} menuKey='ITEM_HIST'/>} />
            <Route path="/admin/items/rel" element={<AdminContainers target={<ItemsRelMain />} menuKey='ITEM_REL'/>} />

            <Route path="/admin/inspects" element={<AdminContainers target={<InspectMain />} menuKey='INSPECT'/>} />
            <Route path="/admin/inspects/:sno/ispDetail" element={<AdminContainers target={<InspectHistMain />} menuKey='PARAM_MENU_INSPECT'/>} />

            <Route path="/admin/supplies" element={<AdminContainers target={<Supplies />} menuKey='SUPPLIES_LIST'/>} />

            <Route path="/admin/inout" element={<AdminContainers target={<InoutMain />} menuKey='INOUT_LIST'/>} />
            <Route path="/admin/inoutHist" element={<AdminContainers target={<InoutHist />} menuKey='INOUT_HIST'/>} />
            <Route path="/admin/inout/:sno/inoutDetail" element={<AdminContainers target={<InoutHistMain />} menuKey='PARAM_MENU_INOUT'/>} />
            <Route path="/admin/inoutMod" element={<AdminContainers target={<InoutMod />} menuKey='INOUT_MOD'/>} />

            <Route path="/admin/static/item" element={<AdminContainers target={<StaticItem />} menuKey='STATIC_ITEM'/>} />
            <Route path="/admin/static/searchItem" element={<AdminContainers target={<StaticSearchItem />} menuKey='STATIC_SEARCH'/>} />
            <Route path="/admin/static/inout" element={<AdminContainers target={<StaticInout />} menuKey='STATIC_INOUT'/>} />
            <Route path="/admin/static/inspect" element={<AdminContainers target={<StaticInspect />} menuKey='STATIC_INSPECT'/>} />

            <Route path="/admin/setting/password" element={<AdminContainers target={<Password />} menuKey='PASSWORD'/>} />
            <Route path="/admin/setting/users" element={<AdminContainers target={<Users />} menuKey='USERS'/>} />
            <Route path="/admin/setting/client" element={<AdminContainers target={<Client />} menuKey='CLIENT'/>} />

        </Routes>
    )
}

export default MainRoutes;